var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('registrable-manged-player-selector'),_c('div',{staticClass:"member-container"},[_c('card',{staticClass:"right-panel-container"},[_c('content-component')],1),_c('count-down')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }